/**
 * SocialIcons — Branded social media icons with hover effects.
 * Each icon uses its platform's official brand color on hover for maximum recognition.
 */

export const SOCIALS = [
  {
    key: "facebook",
    label: "Seguici su Facebook",
    url: "https://www.facebook.com/profile.php?id=61573301631902",
    bg: "#1877F2",
    svg: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
  },
  {
    key: "instagram",
    label: "Seguici su Instagram",
    url: "https://www.instagram.com/utile_rent/",
    bg: "linear-gradient(45deg, #F58529, #DD2A7B, #8134AF, #515BD4)",
    svg: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
      </svg>
    ),
  },
  {
    key: "tiktok",
    label: "Seguici su TikTok",
    url: "https://www.tiktok.com/@utile.rent",
    bg: "#000000",
    svg: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005.8 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1.84-.1z"/>
      </svg>
    ),
  },
];

/**
 * variant: "pill" (large colored brand buttons) | "square" (compact outlined, hover fills brand color)
 * size: "sm" | "md" | "lg"
 */
export default function SocialIcons({ variant = "pill", size = "md", className = "" }) {
  const sizeMap = { sm: "w-9 h-9", md: "w-11 h-11", lg: "w-14 h-14" };
  const iconSize = { sm: "w-4 h-4", md: "w-5 h-5", lg: "w-6 h-6" };

  if (variant === "pill") {
    return (
      <div className={`flex items-center gap-3 ${className}`}>
        {SOCIALS.map((s) => (
          <a
            key={s.key}
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={s.label}
            data-testid={`social-${s.key}`}
            className={`group relative ${sizeMap[size]} flex items-center justify-center text-white shadow-lg transition-transform hover:-translate-y-1 hover:scale-110`}
            style={{ background: s.bg }}
          >
            <span className={iconSize[size]}>{s.svg}</span>
            <span className="absolute inset-0 ring-2 ring-[#22ff66] opacity-0 group-hover:opacity-100 transition" />
          </a>
        ))}
      </div>
    );
  }

  // square outlined (for footer)
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {SOCIALS.map((s) => (
        <a
          key={s.key}
          href={s.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={s.label}
          data-testid={`social-${s.key}`}
          className={`group relative overflow-hidden ${sizeMap[size]} border border-white/10 flex items-center justify-center text-white transition-all hover:text-white hover:border-transparent hover:shadow-lg`}
        >
          <span
            className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            style={{ background: s.bg }}
          />
          <span className={`${iconSize[size]} relative z-10`}>{s.svg}</span>
        </a>
      ))}
    </div>
  );
}
